<template>
    <div className="contain">
        <input
            ref="txtInput"
            type="file"
            accept=".txt"
            style="display: none"
            @change="onTxtChange"
        />
        <ButtonField text="将json转化经纬度" @click="convert" secondary style="margin-right: 1rem;width:150px;"/>
        <ButtonField text="list" @click="executeAll" secondary style="margin-right: 1rem;width:150px;"/>
    </div>
</template>

<script>
/* ===== 1. 仿射变换类 ===== */
class RobustAffineTransform {
    constructor(srcPts, dstPts, lonOffset = 0, latOffset = 0) {
        if (srcPts.length < 3) throw new Error('至少需要 3 个控制点')
        this.params = this._computeTransform(srcPts, dstPts)
        this.lonOffset = lonOffset
        this.latOffset = latOffset
    }

    forward(x, y) {
        const {a, b, c, d, e, f} = this.params
        return [
            a * x + b * y + c, //+ this.lonOffset,
            d * x + e * y + f //+ this.latOffset
        ]
    }

    _computeTransform(srcPts, dstPts) {
        const n = srcPts.length
        let srcCentroidX = 0, srcCentroidY = 0, dstCentroidX = 0, dstCentroidY = 0
        for (let i = 0; i < n; i++) {
            srcCentroidX += srcPts[i][0];
            srcCentroidY += srcPts[i][1]
            dstCentroidX += dstPts[i][0];
            dstCentroidY += dstPts[i][1]
        }
        srcCentroidX /= n;
        srcCentroidY /= n;
        dstCentroidX /= n;
        dstCentroidY /= n
        const srcRelative = srcPts.map(([x, y]) => [x - srcCentroidX, y - srcCentroidY])
        const dstRelative = dstPts.map(([x, y]) => [x - dstCentroidX, y - dstCentroidY])
        let Sxx = 0, Sxy = 0, Syx = 0, Syy = 0, SxX = 0, SxY = 0, SyX = 0, SyY = 0
        for (let i = 0; i < n; i++) {
            const [dx, dy] = srcRelative[i];
            const [dX, dY] = dstRelative[i]
            Sxx += dx * dx;
            Sxy += dx * dy;
            Syx += dy * dx;
            Syy += dy * dy
            SxX += dx * dX;
            SxY += dx * dY;
            SyX += dy * dX;
            SyY += dy * dY
        }
        const det = Sxx * Syy - Sxy * Syx
        if (Math.abs(det) < 1e-15) throw new Error('控制点共线')
        const a = (SxX * Syy - SyX * Sxy) / det
        const b = (SyX * Sxx - SxX * Syx) / det
        const d = (SxY * Syy - SyY * Sxy) / det
        const e = (SyY * Sxx - SxY * Syx) / det
        const c = dstCentroidX - (a * srcCentroidX + b * srcCentroidY)
        const f = dstCentroidY - (d * srcCentroidX + e * srcCentroidY)
        return {a, b, c, d, e, f}
    }
}

/* ===== 2. 控制点 ===== */
const cadCtrl = [
    [502820.0210,3651490.8970],
    [502896.9852, 3652878.7344],
    [502498.5840, 3652301.4070],
    [503067.0800,3653652.3350],
    [501124.2378,3652461.6689],
    [501813.3236,3651987.4277]
]
const wgsCtrl = [
    [118.536652717532,32.9866995126115],
    [118.53763460135008, 32.99912992356043],
    [118.53319674968486, 32.99408443110017],
    [118.539291688974,33.0061974066443],
    [118.518571,32.995504],
    [118.525915,32.991203]
]

/* ===== 3. 计算偏移量 ===== */
const actualLon = 118.53981293070824
const actualLat = 33.00664170052942
const expectedLon = 118.53972901782117
const expectedLat = 33.00683030660269
const lonOffset = expectedLon - actualLon
const latOffset = expectedLat - actualLat

/* ===== 4. 生成全局转换器（已带偏移） ===== */
const transformer = new RobustAffineTransform(cadCtrl, wgsCtrl, lonOffset, latOffset)

import {saveLine, saveTest1} from '@/views/topic/detection/api/detection'

export default {
    name: 'Index',
    data() {
        return {
            isSubmitting: false,
            list: [] // 添加list数据
        }
    },
    methods: {
        async convert() {
            const res = await fetch('/1.json')
            const pointArr = await res.json()
            console.log("pointArr:::", pointArr)

            const point1 = pointArr;
            this.list = point1.map(p => {
                const [lon, lat] = transformer.forward(p.x, p.y)
                return {...p, lon, lat}
            })
            console.log("转换后的list:", this.list)
        },

        // 生成随机ID
        generateRandomId() {
            return Math.floor(Math.random() * 1000000);
        },

        // 解析高程值
        parseElevationValue(value) {
            if (value === null || value === undefined || value === "null" || value === "" || value === " ") {
                return null;
            }
            // 去除所有空格和分号，取第一个值
            const cleaned = value.toString().trim().replace(/\s/g, '').replace(/;/g, ',');
            const values = cleaned.split(',');
            const result = parseFloat(values[0]);
            return isNaN(result) ? null : result;
        },

// 在 calculateDepth
        calculateDepth(item) {
            // 注意：这里使用 item['rain_elevation '] 因为字段名确实有空格
            const elevation = this.parseElevationValue(item.swage_elevation || item['rain_elevation ']);
            if (elevation === null) return null;

            let groundElevation = null;

            // 优先使用east，如果没有则使用west
            if (item.east && item.east !== "null") {
                groundElevation = this.parseElevationValue(item.east);
            } else if (item.west && item.west !== "null") {
                groundElevation = this.parseElevationValue(item.west);
            }

            if (groundElevation === null) return null;

            return (elevation - groundElevation).toFixed(2);
        },
        // 执行addTest方法
        async executeAddTest() {
            console.log('开始执行addTest方法...');

            for (const item of this.list) {
                if (item.code === null && item.x === null && item.y === null) {
                    continue;
                }

                // 修正高程字段引用
                const depth = this.calculateDepth(item);
                const elevation = this.parseElevationValue(item.swage_elevation || item['rain_elevation ']);

                const form = {
                    id: this.generateRandomId(),
                    x: item.lon,
                    y: item.lat,
                    code: item.code,
                    accessary: '山水大道',
                    depth: depth,
                    location: elevation  // 使用修正后的高程值
                };

                console.log('执行addTest:', form);
                try {
                    await this.addTest(form);
                    console.log(`成功添加测试点: ${item.code}`);
                } catch (error) {
                    console.error(`添加测试点失败: ${item.code}`, error);
                }
            }

            console.log('addTest方法执行完成！');
        },

        // 执行addLine方法
        async executeAddLine() {
            console.log('开始执行addLine方法...');
            const segments = [];
            let currentSegment = [];

            for (const item of this.list) {
                if (item.code === null && item.x === null && item.y === null) {
                    if (currentSegment.length > 0) {
                        segments.push([...currentSegment]);
                        currentSegment = [];
                    }
                } else {
                    currentSegment.push(item);
                }
            }

            if (currentSegment.length > 0) {
                segments.push(currentSegment);
            }

            console.log('分段结果:', segments);

            for (const segment of segments) {
                for (let i = 0; i < segment.length - 1; i++) {
                    const fromItem = segment[i];
                    const toItem = segment[i + 1];

                    // 修正高程字段引用
                    const elevationFrom = this.parseElevationValue(fromItem.swage_elevation || fromItem['rain_elevation ']);
                    const elevationTo = this.parseElevationValue(toItem.swage_elevation || toItem['rain_elevation ']);

                    const depthFrom = this.calculateDepth(fromItem);
                    const depthTo = this.calculateDepth(toItem);

                    console.log(`高程检查 - From: ${fromItem.code}`, {
                        swage: fromItem.swage_elevation,
                        rain: fromItem['rain_elevation '],
                        parsed: elevationFrom
                    });
                    console.log(`高程检查 - To: ${toItem.code}`, {
                        swage: toItem.swage_elevation,
                        rain: toItem['rain_elevation '],
                        parsed: elevationTo
                    });

                    const form = {
                        id: this.generateRandomId(),
                        xform: fromItem.lon,
                        yform: fromItem.lat,
                        xto: toItem.lon,
                        yto: toItem.lat,
                        pointFrom: fromItem.code,
                        pointTo: toItem.code,
                        diameter: fromItem.material,
                        elevationFrom: elevationFrom,
                        buringDepthFrom: depthFrom,
                        elevationTo: elevationTo,
                        buringDepthTo: depthTo,
                        code: this.makeCode(fromItem.code, toItem.code),
                    };

                    console.log('执行addLine:', form);
                    try {
                        await this.addLine(form);
                        console.log(`成功添加连线: ${fromItem.code} → ${toItem.code}`);
                    } catch (error) {
                        console.error(`添加连线失败: ${fromItem.code} → ${toItem.code}`, error);
                    }
                }
            }

            console.log('addLine方法执行完成！');
        },
        makeCode(from, to){
            const normalize = s => s.replace(/-(\d+)$/, (_, n) => n.padStart(3, '0'));
            return `${normalize(from)}-${normalize(to)}`.toUpperCase();
        },
        // 执行所有方法
        async executeAll() {
            if (this.list.length === 0) {
                this.$message.warning('请先转换JSON数据');
                return;
            }

            console.log('开始执行所有方法...');

            try {
                await this.executeAddTest();
                await this.executeAddLine();
                this.$message.success('所有数据导入完成！');
            } catch (error) {
                console.error('执行过程中出错:', error);
                this.$message.error('数据导入过程中出现错误');
            }
        },

        // addTest API调用
        addTest(form) {
            return new Promise((resolve, reject) => {
                this.isSubmitting = true
                saveTest1(form)
                    .then(() => {
                        this.$message.success(`测试点 ${form.code} 保存成功`)
                        resolve()
                    })
                    .catch(err => {
                        console.error(err)
                        this.$message.error(`测试点 ${form.code} 保存失败`)
                        reject(err)
                    })
                    .finally(() => (this.isSubmitting = false))
            })
        },

        // addLine API调用
        addLine(form) {
            return new Promise((resolve, reject) => {
                this.isSubmitting = true
                saveLine(form)
                    .then(() => {
                        this.$message.success(`连线 ${form.point_from} → ${form.point_to} 保存成功`)
                        resolve()
                    })
                    .catch(err => {
                        console.error(err)
                        this.$message.error(`连线 ${form.point_from} → ${form.point_to} 保存失败`)
                        reject(err)
                    })
                    .finally(() => (this.isSubmitting = false))
            })
        },

        async saveForms(forms) {
            for (const f of forms) {
                await this.addTest(f)
            }
            this.$message.success(`index.txt 数据已全部导入，共 ${forms.length} 条数据`)
        }
    }
}
</script>

